import "./positionGroup.sass";

const DEFAULT_SLOTS = 3;

export default function PositionGroup({ pos, players, removePlayer, accentColor, accentColorAlt, posIndex }) {
  const isEmpty = players.length === 0;
  const slots = isEmpty ? DEFAULT_SLOTS : players.length;

  // Alterna entre accentColor y accentColorAlt para los grupos pares (índice 1 y 3)
  const titleBg = (posIndex % 2 === 1) && accentColorAlt ? accentColorAlt : accentColor;

  return (
    <div className="lsp-group">
      <h4 className="lsp-group__title" style={accentColor ? { background: titleBg, borderColor: titleBg } : undefined}>{pos}s</h4>
      <ul className="lsp-group__list">
        {Array.from({ length: slots }, (_, i) => {
          const player = players[i];
          return isEmpty ? (
            <li key={`empty-${i}`} className={`lsp-group__empty ${(i + 1) % 2 === 0 ? "lsp-group__even" : "lsp-group__odd"}`}>—</li>
          ) : (
            <li key={player.index} className={`lsp-group__item ${(i + 1) % 2 === 0 ? "lsp-group__even" : "lsp-group__odd"}`}>
              <span>{player.nombre}</span>
              <button onClick={() => removePlayer(player.index)} aria-label={`Eliminar ${player.nombre}`}></button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}